/**
 * Mi perfil (P40) · el usuario autenticado consulta y edita SU cuenta.
 * Roles/áreas/organizaciones son de solo lectura (las gestiona el admin).
 */
import { axiosClient } from "@/shared/api/axios-client";

export interface MiPerfil {
  id: string;
  email: string;
  fullName: string;
  roles: string[];
  dosFactoresHabilitado: boolean;
}

export interface MisAsignaciones {
  areas: string[];
  organizaciones: string[];
}

export async function obtenerMiPerfil(): Promise<MiPerfil> {
  const { data } = await axiosClient.get<MiPerfil>("/api/auth/perfil");
  return data;
}

export async function obtenerMisAsignaciones(): Promise<MisAsignaciones> {
  const { data } = await axiosClient.get<MisAsignaciones>("/api/catalogos/mis-asignaciones");
  return data;
}

export async function actualizarMiPerfil(args: {
  fullName: string;
  email: string;
}): Promise<MiPerfil> {
  const { data } = await axiosClient.put<MiPerfil>("/api/auth/perfil", args);
  return data;
}

// NOTA: no hay cambio de contraseña autenticado · la contraseña solo se
// cambia con el enlace de restablecimiento (ver CardRestablecerPassword).
